<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2">OSBOD Urenverantwoording - Administratie</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-title>
			<v-text-field v-model="search" append-icon="mdi-magnify" label="Filter" single-line hide-details></v-text-field>
		</v-card-title>

		<v-data-table :headers="headers" :items="data" :search="search" :loading="loading">
			<template v-slot:top>
				<v-toolbar dark dense color="primary" flat class="mb-1">
					<v-btn depressed class="ml-2" @click="setEmployeeTimesheet()" color="inverted">
						<v-icon class="pr-2">mdi-plus-circle</v-icon>Nieuwe Urenverantwoording
					</v-btn>
				</v-toolbar>
			</template>
			<template v-slot:item.action="{ item }" >
				<v-icon @click="handleClick(item.id)">mdi-account-edit</v-icon>
			</template>
		</v-data-table>
	</v-card>
</template>
 
 <script>
import Axios from "axios";
//import _ from "lodash";
import { API_ROOT } from "../../config";
console.log(API_ROOT.osbod_salary);
const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 60000
});

export default {
	name: "timesheets",
	data() {
		return {
			//user: localStorage.getItem("user"),
			search: "",
			headers: [
				{
					text: "",
					align: "center",
					sortable: false,
					value: "action"
				},
				// { text: "Schooljaar", value: "tbl_sys_schoolyear.name" },
				// { text: "Periode", value: "tbl_sys_periode.name" },
				{ text: "Week", value: "tbl_sys_week.week" },
				{ text: "Datum", value: "tbl_sys_calendar.fulldate" },
				{ text: "Uren", value: "tbl_sys_hour.name" },
				{ text: "Minuten", value: "tbl_sys_minute.name" },
				{ text: "Werklocatie", value: "tbl_sys_worklocation.name" },
				{ text: "To do", value: "tbl_admin_task.name" },
				{ text: "Uitgevoerde taken", value: "tbl_sys_task.name" },
				{ text: "Omschrijving", value: "description" },
				// { text: "Urenverantwoording", value: "tbl_sys_schoolyear.name" },
				// { text: "First Check", value: "firstcheckby"},
				// { text: "Second Check",	value: "secondcheckby"},
				// { text: "Active", value: "tbl_timesheet.timesheet_active" }

			],
			// semesters: [],
			// studies: [],
			// subjects: [],
			// subjecttypes: [],
			// selected_subject: null,
			// selected_kwalificatie: null,
			// selected_deelkwalificatie: null,
			// selected_semester: null,
			// schoolyear: [],
			// selected_schoolyear: null,
			data: [],
			user: JSON.parse(localStorage.getItem("user")),
			// banktypes: [],
			isEmpty: false,
			loading: false,
			isPaginated: true,
			isPaginationSimple: false,
			defaultSortDirection: "asc",
			currentPage: 1,
			perPage: 15
		};
	},
	created: function() {
		// this.getBanktypes();
		this.getEmployeeTimesheets();
	},
	watch: {
		// selected_kwalificatie: function(value) {
		// 	this.getStudySubjecttype(value);
		// 	console.log(value);
		// }
	},
	computed: {
		// school() {
		// 	return this.$store.getters.getSchool;
		// }
	},
	methods: {
		handleClick(id) {
			this.$router.push({
				path: "/schooladmin/admin_timesheet/update/" + id
			});
		},
		setEmployeeTimesheet: function() {
			this.$router.push({
				path: "/schooladmin/admin_timesheet/new"
			});
		},
		getEmployeeTimesheets: function() {
			var self = this;
			this.loading = true;
			// ax.get("/admin_timesheet/all").then(function(response) {
			// 		// console.log(response.data);
			// 	self.data = response.data;
			// 	console.log("Urenverantwoording fetched...");
			// 	console.log(response.data);
			// 	self.loading = false;
			// });

			ax.get("/admin_timesheet/user_task/", {
					params: {
						user_id: this.user.id
					}
				}).then(function (response) {
				self.data = response.data;
				console.log("Urenverantwoording fetched...");
				console.log(response.data);
				self.loading = false;
				});


		},
		// getBanktypes: function() {
		// 	var self = this;
		// 	ax.get("/banktype/all").then(function(response) {
		// 		console.log(response.data);
		// 		self.banktypes = response.data;
		// 	});
		// }
	}
};
</script>
 
 <!-- Add "slot-scoped" attribute to limit CSS to this component only -->
 <style slot-scoped>
</style>